// extracted by mini-css-extract-plugin
export default {"sub-question":"SubQuestion_sub-question__Ui4nq","sub-question-controls":"SubQuestion_sub-question-controls__yeoVN","sub-question-icons":"SubQuestion_sub-question-icons__GJqrg"};